var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entity-view-pill-list"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"entity-view-pill-list__pill"},[_vm._v(_vm._s(item.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }